const LANG_TO_COUNTRY: Record<string, string> = {
  th: 'TH',
  zh: 'CN',
  vi: 'VN',
  km: 'KH',
  lo: 'LA',
  my: 'MM',
};

/**
 * Localize a bank's display name: show the native-script name (`localName`) only
 * to users whose UI language is that bank's home country, otherwise the Latin /
 * English `name`. Data carries one native name per bank, not per-locale, so a
 * Thai user sees Thai for TH banks but English for foreign ones.
 */
export function bankLabel(
  bank: { name: string; localName?: string | null; country?: string | null },
  lang: string,
): string {
  const native = LANG_TO_COUNTRY[lang.split('-')[0] ?? ''];
  if (native && bank.country === native && bank.localName) return bank.localName;
  return bank.name;
}
